module.exports = __webpack_public_path__ + "media/images/bg-content-19c6f8f2bf2ae93e303f2f21001ea1eb.png";